import {AbstractVisualFeature} from '../../../visual-feature.js';
import {Racing} from '../racing.js';

import {raceMeetingsFactory} from './race-meetings.factory';

import PALETTE_SCHEMA from './race-meetings.palette-schema.yaml';

class RaceMeetingsFeature extends AbstractVisualFeature {
    get name() {
        return 'RaceMeetings';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return raceMeetingsFactory(PALETTE);
    }
}

if (FEATURES.racing) {
    new RaceMeetingsFeature(Racing);
}
